import FactoringApi from '@/api-interface/factoring'

export default {
  namespaced: true,

  state: {
    pendingApprovals: []
  },

  getters: {
    pendingApprovalCarriers(state) {
      return state.pendingApprovals
        .filter((entity) => entity.factoringProviderApprovalEntityType === 'account')
        .map((entity) => ({ ...entity, ...entity.factoringProviderEntity }))
    },

    pendingApprovalShippers(state) {
      return state.pendingApprovals
        .filter((entity) => entity.factoringProviderApprovalEntityType === 'company')
        .map((entity) => ({ ...entity, ...entity.factoringProviderEntity }))
    }
  },

  mutations: {
    SET_PENDING_LIST(state, entities) {
      state.pendingApprovals = entities
    },

    REMOVE_CARRIER(state, carrierKey) {
      const DELETE_COUNT = 1
      const targetIndex = state.pendingApprovals.findIndex(
        (entity) => entity.factoringProviderEntity.accountKey === carrierKey
      )
      state.pendingApprovals.splice(targetIndex, DELETE_COUNT)
    },

    REMOVE_SHIPPER(state, shipperKey) {
      const DELETE_COUNT = 1
      const targetIndex = state.pendingApprovals.findIndex(
        (entity) => entity.factoringProviderEntity.companyKey === shipperKey
      )
      state.pendingApprovals.splice(targetIndex, DELETE_COUNT)
    }
  },

  actions: {
    async approveShipper({ commit, rootGetters }, shipperKey) {
      await FactoringApi.approve({
        factoringProviderKey: rootGetters['user/accountInfo'].factoringProvider.factoringProviderKey,
        factoringProviderApprovalEntityType: 'company',
        factoringProviderApprovalEntityKey: shipperKey
      })

      commit('REMOVE_SHIPPER', shipperKey)
    },

    async approveCarrier({ commit, rootGetters }, carrierKey) {
      await FactoringApi.approve({
        factoringProviderKey: rootGetters['user/accountInfo'].factoringProvider.factoringProviderKey,
        factoringProviderApprovalEntityType: 'account',
        factoringProviderApprovalEntityKey: carrierKey
      })

      commit('REMOVE_CARRIER', carrierKey)
    },

    async preApproveCarrier({ rootGetters }, carrierKey) {
      await FactoringApi.preApprove({
        factoringProviderKey: rootGetters['user/accountInfo'].factoringProvider.factoringProviderKey,
        factoringProviderApprovalEntityType: 'account',
        factoringProviderApprovalEntityKey: carrierKey
      })
    },

    async rejectShipper({ commit, rootGetters }, shipperKey) {
      await FactoringApi.reject({
        factoringProviderKey: rootGetters['user/accountInfo'].factoringProvider.factoringProviderKey,
        factoringProviderApprovalEntityType: 'company',
        factoringProviderApprovalEntityKey: shipperKey
      })

      commit('REMOVE_SHIPPER', shipperKey)
    },

    async rejectCarrier({ commit, rootGetters }, carrierKey) {
      await FactoringApi.reject({
        factoringProviderKey: rootGetters['user/accountInfo'].factoringProvider.factoringProviderKey,
        factoringProviderApprovalEntityType: 'account',
        factoringProviderApprovalEntityKey: carrierKey
      })

      commit('REMOVE_CARRIER', carrierKey)
    },

    async fetchPendingApprovals({ commit, rootGetters }) {
      const factoringProviderKey = rootGetters['user/accountInfo'].factoringProvider.factoringProviderKey
      const combinedList = await FactoringApi.pendingApprovals(factoringProviderKey)
      commit('SET_PENDING_LIST', combinedList)
    }
  }
}
